import PropTypes from "prop-types"
import React from "react"
import * as style from "./style.module.css"

const InputLabel = ({ forTxt, labelText }) => {
  return (
    <label
      // for={forTxt}
      htmlFor={forTxt}
      className={style.d_none}
      aria-label={labelText}
    >
      {labelText}
    </label>
  )
}

InputLabel.prototype = {
  forTxt: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
}

export default InputLabel
